// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-info-page',
    emits: ["command"],
    // #endregion
    // #region Properties
    props: {
        process: {
            type: Object,
            required: false,
            default: {}
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
        data: {
            type: Object,
            required: false,
            default: {}
        },
        page: {
            type: Object,
            required: false,
            default: {}
        },
        master: {
            type: Object,
            required: false,
            default: {}
        },
    },
    computed: {
        uploadUrlFile() {
            return '/frontend/v1/forms/Processes/' + this.schema.processID + '/files?source=form';
        }
    },
    data: () => ({}),
    // #endregion
    // #region Core
    methods: {
        onGotoHome() {
            this.$router.push({ path: "/ozg" });
        },
        onCommand(command, args) {
            this.$emit('command', command, args);
        },
    },
    // #endregion
});
// #endregion
